export default __webpack_public_path__ + "static/media/9.58fd79cf.svg";